/**
 * Panel definitions for forward/electricity commodity
 * Add your electricity-related panels here based on backend dataset configs
 */
export const forwardElectricityPanels = [
  // First row: 2 panels side-by-side (12 cols each)
  {
    id: 'cals-power-base',
    type: 'datasetChart',
    datasetId: 'ice-power-base',
    visualizationId: 'ice-power-base-chart',
    labelOverrides: { descriptionKey: 'dashboard_panels.power_base_forward_curve' },
    gridPos: { x: 0, y: 0, w: 12, h: 15 },
  },
  {
    id: 'power-base-monthly-settlments',
    type: 'datasetChart',
    datasetId: 'ice-power-base-monthly',
    visualizationId: 'ice-power-base-monthly-monthly-settlements',
    gridPos: { x: 12, y: 0, w: 12, h: 15 },
  },
  // Second row: 2 panels side-by-side (12 cols each)
  {
    id: 'cals-power-peak',
    type: 'datasetChart',
    datasetId: 'ice-power-base',
    visualizationId: 'ice-power-base-power-peak-chart',
    gridPos: { x: 0, y: 15, w: 12, h: 15 },
  },
  {
    id: 'ice-dutch-power-off-peak-futures',
    type: 'datasetChart',
    datasetId: 'ice-dutch-power-off-peak-futures',
    visualizationId: 'dutch-power-off-peak-futures-forward-curve',
    gridPos: { x: 12, y: 15, w: 12, h: 15 },
  },
  {
    id: 'gas-power-calendar-comparison',
    type: 'datasetChart',
    datasetId: 'ice-cals-ttf-gas',
    visualizationId: 'cals-ttf-gas-power-calendar-comparison',
    gridPos: { x: 0, y: 30, w: 24, h: 15 },
  },
];

export const forwardElectricitySyncGroups = [
  {
    id: 'power-country',
    global: false,
    ids: ['cals-power-base', 'cals-power-peak'],
    syncFilters: ['country'],
  },
  {
    id: 'power-top-row',
    global: false,
    ids: ['cals-power-base', 'power-base-monthly-settlments'],
    syncAxes: { y: true },
  },
  {
    id: 'power-bottom-row',
    global: false,
    ids: ['cals-power-peak', 'ice-dutch-power-off-peak-futures'],
    syncAxes: { y: true },
  },
];
